<template>
  <section class="mb-64 dashboard-job-carousel">
    <h3 v-if="!requireJobPost && hasJobHistory" class="text-h4 mb-4">Start your job post here:</h3>
    <p class="body-1 mb-16">{{ carouselHeading }}</p>
    <div class="dashboard-job-carousel__clip">
      <div class="dashboard-job-carousel__box">
        <ul :class="carouselClasses">
          <li>
            <a class="dashboard-job-carousel__card" href="/job-post">
              <BabysitterIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Child care</span>
              <ArrowIcon />
            </a>
          </li>
          <li v-if="corporate">
            <a class="dashboard-job-carousel__card" href="/job_posting/new?care_type=housekeeping">
              <HousekeepingIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Housekeeping</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="dashboard-job-carousel__card" href="/job_posting/new?care_type=pet_care">
              <PetCareIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Pet care</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="dashboard-job-carousel__card" href="/job_posting/new?care_type=special_needs">
              <SpecialNeedsIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Special needs care</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="dashboard-job-carousel__card" href="/job_posting/new?care_type=companion_care">
              <SeniorCareIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Companion care</span>
              <ArrowIcon />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import BabysitterIllustration from '@/graphics/illustrations/BabysitterIllustration.vue';
import PetCareIllustration from '@/graphics/illustrations/PetCareIllustration.vue';
import SeniorCareIllustration from '@/graphics/illustrations/SeniorCareIllustration.vue';
import SpecialNeedsIllustration from '@/graphics/illustrations/SpecialNeedsIllustration.vue';
import HousekeepingIllustration from '@/graphics/illustrations/HousekeepingIllustration.vue';
import ArrowIcon from '@/graphics/icons/ArrowIcon.vue';
import { readMeta } from '@/lib/page';

export default {
  name: 'JobPostCarousel',
  components: {
    BabysitterIllustration,
    PetCareIllustration,
    SeniorCareIllustration,
    SpecialNeedsIllustration,
    HousekeepingIllustration,
    ArrowIcon,
  },
  props: {
    accountType: {
      type: String,
      required: true,
    },
    hasJobHistory: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasJobs(): boolean {
      return this.hasJobHistory;
    },
    requireJobPost() {
      return readMeta('require-job-post');
    },
    corporate(): boolean {
      return this.accountType === 'corporate';
    },
    premium(): boolean {
      return this.accountType === 'premium';
    },
    basic(): boolean {
      return !(this.premium || this.corporate);
    },
    carouselHeading(): string {
      if (!this.hasJobs) {
        return 'Skip the scrolling and searching. Share how you need help and matching caregivers will reach out to you.';
      }

      return 'Share how you need help and caregivers will apply to introduce themselves.';
    },
    carouselClasses(): Array<string> {
      const classes = ['dashboard-job-carousel__main'];

      return classes;
    },
  },
};
</script>
